import React from 'react';
import { Container, Input, Table } from 'semantic-ui-react';
import { useTranslation } from 'react-i18next';
import Button from '../../semantic/Button';
import { FieldArray, useFormikContext } from 'formik';
import { ActionButtonWithIcon } from '../../semantic/ActionButtonWithIcon';

type Labels = string[];

export default function ProviderLabels() {
  const { t } = useTranslation();
  const formik = useFormikContext<{ labels: Labels }>();
  const labels = formik.values.labels || [];

  return (
    <Container>
      <h4>{t('editProvider.labelsTitle', 'Labels')}</h4>
      <FieldArray
        name="labels"
        render={(arrayHelpers) => (
          <>
            <Table style={{ tableLayout: 'fixed' }}>
              <Table.Header>
                <Table.Row>
                  <Table.HeaderCell width={8}>
                    <span>{t('editProvider.labels', 'Label')}</span>
                  </Table.HeaderCell>
                  <Table.HeaderCell width={1}></Table.HeaderCell>
                </Table.Row>
              </Table.Header>
              <Table.Body>
                {labels.map((label, index) => (
                  <Table.Row key={index}>
                    <Table.Cell>
                      <Input
                        value={label}
                        onChange={(_, { value }) => {
                          const newLabels = [...formik.values.labels];
                          newLabels[index] = value;
                          formik.setFieldValue('labels', newLabels);
                        }}
                        style={{ width: '100%' }}
                      />
                    </Table.Cell>
                    <Table.Cell>
                      <Button
                        icon="trash"
                        type="button"
                        onClick={() => arrayHelpers.remove(index)}
                      />
                    </Table.Cell>
                  </Table.Row>
                ))}
              </Table.Body>
            </Table>

            <ActionButtonWithIcon
              text={t('editProvider.addLabel', 'Add Label')}
              icon="plus"
              onClick={() => {
                const newLabels = formik.values.labels
                  ? [...formik.values.labels]
                  : [];
                newLabels.push('');
                formik.setFieldValue('labels', newLabels);
              }}
            />
          </>
        )}
      />
    </Container>
  );
}
